/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style2 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _tool = require('util/tool');

var _config = require('util/config');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.state = {
      baseInfo: []
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.getPagedDeviceVersionList();
    }
  }, {
    key: 'getPagedDeviceVersionList',
    value: function getPagedDeviceVersionList(opt) {
      var _this2 = this;

      var params = this.props.params;

      var page = opt ? opt.current : 1;
      var options = {
        productId: params.id,
        rows: 10,
        page: page
      };
      (0, _tool.http)(_config.apiJson.getPagedDeviceVersionList, options).then(function (res) {
        _this2.setState({
          baseInfo: res
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var baseInfo = this.state.baseInfo;

      var options = [];

      var columns = [{
        title: '',
        dataIndex: 'firmwareVersion',
        key: 'firmwareVersion'
      }, {
        title: '',
        dataIndex: 'deviceCount',
        key: 'deviceCount'
      }];
      var data = [];
      if (baseInfo.rows) [baseInfo.rows.map(function (item, key) {
        item.key = key;
        data.push(item);
      })];
      var pagination = {
        defaultCurrent: 1,
        total: baseInfo.total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return '\u5171\u8BA1 ' + total + ' \u6761';
        },
        showQuickJumper: true
      };

      return (0, _jsx3.default)('div', {
        className: 'remote-level'
      }, void 0, (0, _jsx3.default)(_table2.default, {
        columns: columns,
        dataSource: data,
        pagination: pagination,
        onChange: this.getPagedDeviceVersionList.bind(this)
      }));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: '', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/version/index.jsx
// module id = 1513
// module chunks = 0